import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { msalConfig } from './msal-config'

/**
 * Singleton MSAL client. `initialize()` MUST resolve before we hand this
 * instance to `MsalProvider`; MSAL 3.x throws otherwise. `main.tsx` awaits
 * the promise below before mounting React.
 */
export const msalInstance = new PublicClientApplication(msalConfig)

export const msalReady: Promise<void> = msalInstance
  .initialize()
  .then(() => {
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(accounts[0]!)
    }
    msalInstance.addEventCallback(event => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload &&
        'account' in event.payload &&
        event.payload.account
      ) {
        msalInstance.setActiveAccount(event.payload.account)
      }
    })
  })
  .catch(err => {
    console.error('[msal] initialize failed', err)
  })
